<template>
  <div class="batchUpdateEmployeeStatus">
    <div class="choose">
      <el-select
        v-model="Type"
        class="grade-content-select"
        filterable
        placeholder="请选择员工状态类型"
      >
        <el-option
          v-for="item in Arr"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
    </div>
    <div class="footer">
      <el-button @click="close"> 取消 </el-button>
      <el-button type="primary" @click="confirm"> 确认 </el-button>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import {
  getStaffStatus,
  batchUpdateStaffStatus
} from '@/requet/api/ba/scheduleApi'

export default {
  name: 'BatchUpdateEmployeeStatus',
  props: ['queryParams'],
  emits: ['btnLinkClose'],
  data() {
    return {
      Arr: [],
      Type: '',
      id: []
    }
  },
  watch: {
    queryParams: {
      deep: true,

      handler(newval) {
        console.log('queryParams', newval)
        this.getid()
      }
    }
  },
  mounted() {
    console.log('queryParams', this.queryParams)
    this.getStaffStatus()
    this.getid()
  },
  methods: {
    close() {
      $emit(this, 'btnLinkClose')
    },
    async confirm() {
      // console.log(this.Type)
      let res = await batchUpdateStaffStatus({
        ids: this.id,
        status: this.Type
      })
      $emit(this, 'btnLinkClose')
    },
    async getStaffStatus() {
      this.Arr = []
      let res = await getStaffStatus()
      this.Arr = res
      // console.log(res);
    },
    getid() {
      this.id = []
      if (this.queryParams.length != 0) {
        this.queryParams?.forEach(res => {
          this.id.push(res.F0)
        })
      }
      console.log(this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.batchUpdateEmployeeStatus {
  width: 100%;
  height: 100%;
  position: relative;
  .choose {
    width: 100%;

    .grade-content-select {
      margin-right: 15px;
    }
  }

  .footer {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>
